export default "__VITE_ASSET__6155a33f__"